// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ChatWindow.css */
.chat-window {
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: space-between;
    flex-direction: column;

}

.messages-list {
    overflow-y: auto;
    /* Allow scrolling for overflow content */
    display: flex;
    flex-direction: column;
    gap: 4px;
    /* Reduced gap between messages */
    margin: 1rem .5rem;
    /* Adjusted margin for better spacing */
    height: 100%;
}

.suggestions {
    display: flex;
    flex-wrap: nowrap;
    padding-bottom: 0px;
    /* Reduced from 10px */
    margin-bottom: 5px;
    /* Reduced from 10px */
    align-items: center;
    gap: .5rem;
    white-space: nowrap;
    padding: 0 0rem 0.5rem;
    /* Reduced bottom padding from 1rem to 0.5rem */
}

/* Ensure consistent styling with other pills */
.suggestions>* {
    flex: 0 0 auto;
}

.suggestions-container {
    display: flex;
    align-items: bottom;
    margin-bottom: 0;
    overflow-x: auto;
    /* Adjust this value to decrease space */
}

.inputs-container {
    position: sticky;
    bottom: 0;
    z-index: 999996;
    background-color: #ffffff;
    padding-top: 0px;
    /* Add a small padding at the top */
}

.powered-by {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: .5rem;
    padding: .5rem;
    font-size: .75rem;

    a {
        text-decoration: none;
        color: #3f3f46;
    }
}

.ai-integrations-link {
    color: inherit;
    text-decoration: none;
    transition: color 0.3s ease;
}

.ai-integrations-link:hover {
    color: #007aff;
}

.ai-integrations-link .underline {
    text-decoration: underline;
}

.lead-form-button {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f0f0f0;
    border: none;
    border-radius: 50%;
    width: 36px;
    height: 36px;
    padding: 0;
    margin-left: 10px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    font-size: 20px;
    /* Adjust this to change the size of the emoji */
    line-height: 1;
}

.lead-form-button:hover {
    background-color: #e0e0e0;
    transform: scale(1.05); /* Slightly enlarge on hover */
}`, "",{"version":3,"sources":["webpack://./src/components/ChatWindow/ChatWindow.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,sBAAsB;;AAE1B;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,iCAAiC;IACjC,kBAAkB;IAClB,uCAAuC;IACvC,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;IACV,mBAAmB;IACnB,sBAAsB;IACtB,+CAA+C;AACnD;;AAEA,+CAA+C;AAC/C;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,cAAc;IACd,iBAAiB;;IAEjB;QACI,qBAAqB;QACrB,cAAc;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,iBAAiB;IACjB,eAAe;IACf,sCAAsC;IACtC,eAAe;IACf,gDAAgD;IAChD,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB,EAAE,8BAA8B;AAC1D","sourcesContent":["/* ChatWindow.css */\n.chat-window {\n    display: flex;\n    width: 100%;\n    height: 100%;\n    justify-content: space-between;\n    flex-direction: column;\n\n}\n\n.messages-list {\n    overflow-y: auto;\n    /* Allow scrolling for overflow content */\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    /* Reduced gap between messages */\n    margin: 1rem .5rem;\n    /* Adjusted margin for better spacing */\n    height: 100%;\n}\n\n.suggestions {\n    display: flex;\n    flex-wrap: nowrap;\n    padding-bottom: 0px;\n    /* Reduced from 10px */\n    margin-bottom: 5px;\n    /* Reduced from 10px */\n    align-items: center;\n    gap: .5rem;\n    white-space: nowrap;\n    padding: 0 0rem 0.5rem;\n    /* Reduced bottom padding from 1rem to 0.5rem */\n}\n\n/* Ensure consistent styling with other pills */\n.suggestions>* {\n    flex: 0 0 auto;\n}\n\n.suggestions-container {\n    display: flex;\n    align-items: bottom;\n    margin-bottom: 0;\n    overflow-x: auto;\n    /* Adjust this value to decrease space */\n}\n\n.inputs-container {\n    position: sticky;\n    bottom: 0;\n    z-index: 999996;\n    background-color: #ffffff;\n    padding-top: 0px;\n    /* Add a small padding at the top */\n}\n\n.powered-by {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: .5rem;\n    padding: .5rem;\n    font-size: .75rem;\n\n    a {\n        text-decoration: none;\n        color: #3f3f46;\n    }\n}\n\n.ai-integrations-link {\n    color: inherit;\n    text-decoration: none;\n    transition: color 0.3s ease;\n}\n\n.ai-integrations-link:hover {\n    color: #007aff;\n}\n\n.ai-integrations-link .underline {\n    text-decoration: underline;\n}\n\n.lead-form-button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #f0f0f0;\n    border: none;\n    border-radius: 50%;\n    width: 36px;\n    height: 36px;\n    padding: 0;\n    margin-left: 10px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    font-size: 20px;\n    /* Adjust this to change the size of the emoji */\n    line-height: 1;\n}\n\n.lead-form-button:hover {\n    background-color: #e0e0e0;\n    transform: scale(1.05); /* Slightly enlarge on hover */\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
